export default {
  'stopPaymentRequests.additional': 'Additional Stop Requests',
  'stopPaymentRequest.plural': 'Stop Request(s)',
  'stopPaymentRequests.title': 'Stop Payment',
  'stopPaymentRequests.total': 'Total Stop Requests',
  'stopPaymentRequests.title.plural': 'Stop Request(s)',
  'stopPaymentRequests.response.success': 'Stop payment<%= multiple ?  "s" : "" %> submitted.',
  'stopPaymentRequests.response.error': 'Stop payment<%= multiple ?  "s" : "" %> failed.',
  'stopPaymentRequests.serviceMessage.title': 'Stop Payment Service Message'
};
